namespace $.$$ {
	$mol_style_define( $shm_hitalama_file_attach_pb, {
		Status: {
			minWidth: 0,
			whiteSpace: 'normal',
			overflowWrap: 'anywhere',
			wordBreak: 'break-word',
			flex: { basis: '100%' },
		},
	} )
}
